import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AbschlussBerichtSchema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = AbschlussBerichtSchema.attributes;

const AlleBerichtFelderAbschlussEmobInvest: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Förderung der Elektromobilität" description={PLATZHALTER_TEXT} />

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default AlleBerichtFelderAbschlussEmobInvest;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Foerderung_Der_Elektromo_0232396757_Der_Beschafften_E_Fahrzeuge,
				P.Foerderung_Der_Elektromo_0140144642_fften_Lade_Tankinfrastruktur,
				P.Foerderung_Der_Elektromo_0055030050_rzeuge_Und_Der_Infrastruktur,
				P.Foerderung_Der_Elektromo_0020763651_ung_Des_Beschaffungsvorgangs,
				P.Foerderung_Der_Elektromo_0242001780_arkeit_Der_Elektromobilitaet,
				P.Foerderung_Der_Elektromobilitaet_INVEST_Ausblick,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAlleBerichtFelderAbschlussEmobInvest = () => {
	return concat(formStruc());
};
